import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  actions: () => ({
    setOpened: (item) => ({ item })
  }),

  reducers: ({ actions }) => ({
    opened: [null, PropTypes.any, {
      [actions.setOpened]: (state, payload) => state && payload.item.id === state.id ? null : payload.item
    }]
  })

})



// WEBPACK FOOTER //
// ./src/containers/Results/logic.js